import { QueryClient } from '@tanstack/react-query';

export const invalidateQueries = ({
  invalidateQueryPredicates,
  queryClient,
}: {
  invalidateQueryPredicates: string[];
  queryClient: QueryClient;
}) => {
  const queryCache = queryClient.getQueryCache();

  const queries = queryCache.getAll();

  queries.forEach(query => {
    const { queryKey } = query;

    const queryKeyString = queryKey.toString();

    invalidateQueryPredicates.forEach(predicate => {
      if (queryKeyString?.startsWith(predicate)) {
        void queryClient.invalidateQueries(queryKey);
      }
    });
  });
};
